import { isBefore, isEqual, subDays } from "date-fns";

import { DAYS_BEFORE_WARNING } from "../constants";

export const getExpirationDateWarningColor = (date: Date): string => {
    const dateToCompare = subDays(date, DAYS_BEFORE_WARNING);
    const expirationDateWarning = isBefore(dateToCompare, new Date()) || isEqual(dateToCompare, new Date());
    return expirationDateWarning ? "var(--color-warning)" : "var(--color-grey-900)";
};
